import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Retry2({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="20" cy="20" r="19.3" />
        <path d="M27.556 24A4.442 4.442 0 0 0 32 19.556M27.556 15.111A4.442 4.442 0 0 1 32 19.556M24 15.111l3.556 1.778v-3.556z" />
      </g>
      <path
        className={cx(theme.fill, theme.numberFill, theme.secondFill)}
        d="M10.241 28.494v-1.538l5.435-6.038c.972-1.086 1.631-1.948 1.977-2.586a4.069 4.069 0 0 0 .518-1.96c0-.828-.243-1.525-.73-2.09-.485-.566-1.127-.85-1.925-.85-1.146 0-1.99.293-2.529.878-.54.585-.809 1.413-.809 2.484h-2.153l-.023-.069c-.038-1.428.435-2.628 1.419-3.6.983-.972 2.348-1.458 4.095-1.458 1.497 0 2.687.435 3.572 1.304.885.87 1.328 1.977 1.328 3.321 0 .904-.268 1.808-.804 2.712-.535.904-1.289 1.88-2.261 2.928l-4.364 4.75.023.058h5.89l.183-1.903h1.902v3.657H10.241z"
      />
    </svg>
  )
}

Retry2.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
